(function(root,factory){'use strict';const api=factory();if(typeof module==='object'&&module.exports)module.exports=api;if(root?.document)api.boot(root);})(typeof window==='object'?window:null,function(){
 'use strict';
 const isSlingshot=context=>context?.vehicle?.make==='Polaris'&&context.vehicle.model==='Slingshot'&&Number.isInteger(context.vehicle.year)&&context.vehicle.year>=2018&&context.vehicle.year<=2024;
 const ratedTypes=new Set(['Marine Speakers','Marine Amplifier','Marine Accessories','Powersports Speakers']);
 const recommendationAllowed=(handle,type)=>handle==='soundstream-reserve-ss-1824'||ratedTypes.has(type);
 function boot(win){
  const doc=win.document;let context=null;
  function refresh(){
   context=win.FCSLiveFitment?.read?.()||null;const selected=isSlingshot(context);
   doc.body.classList.toggle('fcs-slingshot-selected',selected);
   doc.querySelectorAll('[data-fcs-standard-upgrades]').forEach(node=>{node.hidden=selected;});
   doc.querySelectorAll('[data-fcs-polaris-upgrades]').forEach(node=>{node.hidden=!selected;});
   const scope=win.FCS_FITMENT_CATEGORY_SCOPE?.products||{};
   doc.querySelectorAll('.product-item,.boost-sd__product-item,.boost-pfs-filter-product-item,.boost-pfs-search-suggest-element,.boost-sd__suggestion-queries-item--product').forEach(card=>{
    if(!selected){delete card.dataset.fcsSlingshotExcluded;return;}
    const href=card.querySelector('a[href*="/products/"]')?.getAttribute('href')||'';let handle='';try{handle=new URL(href,win.location.origin).pathname.match(/\/products\/([a-z0-9_-]+)/)?.[1]||'';}catch{}
    card.dataset.fcsSlingshotExcluded=String(!recommendationAllowed(handle,scope[handle]));
   });
  }
  let timer;const schedule=()=>{clearTimeout(timer);timer=setTimeout(refresh,30);};
  win.addEventListener('fcs:vehicle-change',schedule);
  doc.addEventListener('shopify:section:load',schedule);
  if(doc.readyState==='loading')doc.addEventListener('DOMContentLoaded',refresh,{once:true});else refresh();
  new win.MutationObserver(records=>{if(records.some(record=>record.addedNodes.length))schedule();}).observe(doc.body,{childList:true,subtree:true});
 }
 return{isSlingshot,recommendationAllowed,boot};
});
